import { StateAbbreviation, TtNewBankEnum } from '../gql/generated/graphql';

const { Wa, Mi } = StateAbbreviation;

export const ttJurisdictionDefaultConditions = (state: StateAbbreviation) => ({
  newBank: [Wa, Mi].includes(state) ? TtNewBankEnum.Iccu : undefined,
});
